<template>
    <div :class="selectable ? 'choices-selectable' : ''" class="choices">
        <div :class="activeChoiceIndex === i ? 'choice-container-active' : ''"
             class="choice-container"
             v-bind:key="i"
             v-for="(choice, i) in choices"
        >
            <choice
                    :class="'choice-' + i"
                    class="choice"
                    v-bind:format="choice.format"
                    v-bind:message="choice.message"
                    v-on:click.native="onChoiceClick(i)"
            />
        </div>
    </div>
</template>

<script>
    import Choice from './choice'

    export default {
        props: {
            selectable: {
                type: Boolean,
                required: false,
                default: false
            },
            choices: {
                type: Array,
                required: true
            },
            value: {},

            instantSelection: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        components: {
            Choice
        },
        data() {
            return {
                activeChoiceIndex: -1
            }
        },
        methods: {
            onChoiceClick(clickedChoiceIndex) {
                if (!this.selectable) {
                    return
                }

                if (!this.instantSelection) {
                    this.activeChoiceIndex = clickedChoiceIndex
                }

                this.$emit('value', clickedChoiceIndex)
            }
        }
    }
</script>

<style lang="less">
    @import "~@less/variables.less";

    .teacher-container {
        .choices {
            max-width: 700px;
            margin: 0 auto;
        }
    }

    .choices {
        &.choices-selectable {
            .choice {
                cursor: pointer;
            }
        }

        .choice-container {
            overflow: hidden;
            position: relative;
            border-radius: 5px;
            margin-bottom: 10px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: flex-start;
            align-content: stretch;
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);

            &.choice-container-active {
                .choice {
                    outline: 4px solid black;
                    outline-offset: -4px;
                }
            }
        }

        .choice {
            display: flex;
            width: 100%;

            .bookmark {
                display: flex;
                align-self: stretch;
                flex: 0 1 auto;
                background: @choice-color-1; // The same as choice #0
                width: 15px;
            }

            .content-container {
                display: flex;
                align-self: stretch;
                flex: 1 1 auto;
                background: white;
                padding: 10px 10px 13px 10px;

                .content {
                    margin: 0 auto;
                }
            }

            &.choice-1 .bookmark {
                background: @choice-color-2;
            }

            &.choice-2 .bookmark {
                background: @choice-color-3;
            }

            &.choice-3 .bookmark {
                background: @choice-color-4;
            }

            .send-chat-message {
                margin: 0;
                text-align: center;
            }
        }
    }
</style>